import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import ReactTooltip from 'react-tooltip'
import Select from 'react-select';
import Workbook from 'react-excel-workbook'
import moment from 'moment';
import ReactGA from 'react-ga';
const { proxy } = require('../../ip_api.config')

class Film_PreviewBomVer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            item_no: '',
            description: '',
            onPage: 'Preview',
            arr_temp_edit: [],
            arr_save: [],
            Item: '',
            Name: '',
            value_serach: ''
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/flim/PreviewBomVer');

        if (localStorage.getItem("ID_User") !== null) {
            this.getBom_Preview({})
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    getBom_Preview = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arroption_item = []
        let arroption_name = []
        let url = proxy.server + '/flim/get_bomversion'

        let dataWhere = {
            Item: '',
            Name: '',
        }

        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                // console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arroption_item.push(
                        { value: val.ItemId, label: val.ItemId }
                    )
                    arroption_name.push(
                        { value: val.Name, label: val.Name }
                    )
                }, this)

                let newArray_item = await this.setUniqueArray(arroption_item)
                let newArray_name = await this.setUniqueArray(arroption_name)

                this.setState({
                    option_Item: newArray_item,
                    option_Name: newArray_name
                }, () => {
                    this.previewBomVer()
                })
            })
            .catch((err) => {
                console.log('err', err)
            })
    }

    setUniqueArray = async (arroption) => new Promise((resolve, reject) => {
        let newArray = [];
        let uniqueObject = {};

        for (let i in arroption) {
            let objTitle = arroption[i]['value'];
            uniqueObject[objTitle] = arroption[i];
        }

        for (let i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }
        resolve(newArray)
    })

    allData_Preveiw = () => {
        window.location.reload()
    }

    allData_Preveiw = () => {
        window.location.reload()
    }

    previewBomVer = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })

        const { Item, Name } = this.state
        let arr = []
        let dataWhere = {
            Item: Item,
            Name: Name,
        }

        let url = proxy.server + '/flim/get_bomversion'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.value_serach,
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                arr = await Promise.all(responseJson.result.map(async (val, i) => {

                    return <tr>
                        <td>{this.state.value_serach !== 'IMPORTED' && <bs4.Button color="danger" size='sm' style={{ fontSize: 14 }} onClick={() => this.Delete_bom(val.id, val.db_name, val.BOM_BOMId)}>DEL</bs4.Button>}</td>
                        {
                            val.db_name === 'DPL' ?
                                <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                : val.db_name === 'DFIX' ?
                                    <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DPT' ?
                                        <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                        : ''
                        }
                        <td>{val.Active}</td>
                        <td>{val.Approved}</td>
                        <td>{val.BOM_Approved}</td>
                        <td>{val.BOM_PmfBOMFormula}</td>
                        <td>{val.BOMVersion_ApproverPersonnelNumber}</td>
                        <td>{val.BOM_BOMId}</td>
                        <td>{val.BOM_CheckBOM}</td>
                        <td>{val.BOM_ItemGroupId}</td>
                        <td>{val.BOM_Name}</td>
                        <td>{val.BOM_ApproverPersonnelNumber}</td>
                        <td>{val.Construction}</td>
                        <td>{val.InventSiteId}</td>
                        <td>{val.ItemId}</td>
                        <td>{val.Name}</td>
                    </tr>

                }, this))

                this.setState({
                    arr_save: responseJson.result, previewIBom: arr, isLoading: false, modalPreviewBomline: false,
                    arrDataExcel: responseJson.result, filename: 'BomVersion' + moment().format('YYYYMMDD')
                })
            })
    }

    getBom_Edit = () => {
        this.setState({ modalPreviewBomline: false, isLoading: true, onPage: 'Edit' })

        const { Item, Name } = this.state
        let arr = []
        let dataWhere = {
            Item: Item,
            Name: Name,
        }


        let url = proxy.server + '/flim/get_bomversion'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                dataWhere: dataWhere
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td style={{ justifyContent: 'center' }} data-tip="เลือกแถวที่ต้องการแก้ไข">
                                <bs4.Col>
                                    <ReactTooltip />
                                    <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                        onChange={(e) => this.checkbom(e.target.checked, val.id)} />
                                </bs4.Col>
                            </td>
                            {
                                val.db_name === 'DPL' ?
                                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DFIX' ?
                                        <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                        : val.db_name === 'DPT' ?
                                            <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                            : ''
                            }
                            <td>{val.Active}</td>
                            <td>{val.Approved}</td>
                            <td>{val.BOM_Approved}</td>
                            <td>{val.BOM_PmfBOMFormula}</td>
                            <td>{val.BOMVersion_ApproverPersonnelNumber}</td>
                            <td>{val.BOM_BOMId}</td>
                            <td>{val.BOM_CheckBOM}</td>
                            <td>{val.BOM_ItemGroupId}</td>
                            <td>{val.BOM_Name}</td>
                            <td>{val.BOM_ApproverPersonnelNumber}</td>
                            <td>{val.Construction}</td>
                            <td>{val.InventSiteId}</td>
                            <td>{val.ItemId}</td>
                            <td>{val.Name}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewIBom: arr, isLoading: false, modalPreviewBomline: false })
            })
    }

    checkbom = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    goto_edit = () => {
        this.props.history.push({
            pathname: '/Flim/EditBomVersion',
            state: { id_edit: this.state.arr_temp_edit }
        })
    }

    Delete_bom = (id, db, bom) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true, modalPreviewBomline: false })
            let url = proxy.server + '/flim/delete_bomversion'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                    db: db,
                    bom: bom
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.getBom_Preview()
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        })
                    }
                })
        }
    }

    savetoAX = () => {
        let arr_dpl = this.state.arr_save.filter(x => x.db_name === 'DPL')
        if (arr_dpl.length === 0) {
            alert('ไม่มี Item DPL ให้ import')
        } else {
            if (window.confirm(`กรุณายืนยันการบันทึกเข้า AX DPL จำนวน ${arr_dpl.length} รายการ`)) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/flim/insertBomver_itemToAX'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(arr_dpl)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({ isLoading: false }, () => {
                                alert('บันทึกสำเร็จ')
                                this.getBom_Preview()
                            })
                        } else {
                            this.setState({ isLoading: false }, () => {
                                alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                            })
                        }
                    })
            }
        }
    }

    savetoAXDPT = () => {
        let arr_dpt = this.state.arr_save.filter(x => x.db_name === 'DPT')
        if (arr_dpt.length === 0) {
            alert('ไม่มี Item DPT ให้ import')
        } else {
            if (window.confirm(`กรุณายืนยันการบันทึกเข้า AX DPT จำนวน ${arr_dpt.length} รายการ`)) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/flim/dpt/insertBomver_itemToAX'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(arr_dpt)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({ isLoading: false }, () => {
                                alert('บันทึกสำเร็จ')
                                this.getBom_Preview()
                            })
                        } else {
                            this.setState({ isLoading: false }, () => {
                                alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                            })
                        }
                    })
            }
        }
    }


    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_PreviewBomVer'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Item</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ Item: e.value })}
                            options={this.state.option_Item}
                            placeholder={'ค้นหา Item'}
                        />
                    </bs4.Col>
                    <bs4.Label style={{ marginLeft: 20, fontSize: '16px', fontWeight: 700 }}>Name</bs4.Label>
                    <bs4.Col sm='4'>
                        <Select className="col-md-12"
                            onChange={(e) => this.setState({ Name: e.value })}
                            options={this.state.option_Name}
                            placeholder={'ค้นหา Name'}
                        />
                    </bs4.Col>
                    <bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.previewBomVer()}>SEARCH</bs4.Button>
                    <bs4.Button outline style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.allData_Preveiw()}>ดูข้อมูลทั้งหมด</bs4.Button>
                </bs4.FormGroup>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Col sm='4'>
                        <bs4.Input type='select' onChange={(e) => this.setState({ value_serach: e.target.value }, () => { this.previewBomVer() })}>
                            <option value=''>CREATED</option>
                            <option value='IMPORTED'>IMPORTED</option>
                        </bs4.Input>
                    </bs4.Col>
                    {
                        this.state.value_serach !== 'IMPORTED'
                            ? this.state.onPage === 'Preview'
                                ? <div>
                                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getBom_Edit()}>EDIT</bs4.Button>
                                    <bs4.Button color="primary" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.savetoAX()}>IMPORT TO DPL</bs4.Button>
                                    <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.savetoAXDPT()}>IMPORT TO DPT</bs4.Button>
                                    <Workbook filename={this.state.filename + '.xlsx'} element={<bs4.Button outline color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }}>EXPORT EXCEL</bs4.Button>} >
                                        <Workbook.Sheet data={this.state.arrDataExcel} name="sheet1">
                                            {/* <Workbook.Column label="db_name" value="db_name" /> */}
                                            <Workbook.Column label="Active" value="Active" />
                                            <Workbook.Column label="Approved" value="Approved" />
                                            <Workbook.Column label="BOM_Approved" value="BOM_Approved" />
                                            <Workbook.Column label="BOM_PmfBOMFormula" value="BOM_PmfBOMFormula" />
                                            <Workbook.Column label="BOMVersion_ApproverPersonnelNumber" value="BOMVersion_ApproverPersonnelNumber" />
                                            <Workbook.Column label="BOM_BOMId" value="BOM_BOMId" />
                                            <Workbook.Column label="BOM_CheckBOM" value="BOM_CheckBOM" />
                                            <Workbook.Column label="BOM_ItemGroupId" value="BOM_ItemGroupId" />
                                            <Workbook.Column label="BOM_Name" value="BOM_Name" />
                                            <Workbook.Column label="BOM_ApproverPersonnelNumber" value="BOM_ApproverPersonnelNumber" />
                                            <Workbook.Column label="Construction" value="Construction" />
                                            <Workbook.Column label="InventSiteId" value="InventSiteId" />
                                            <Workbook.Column label="ItemId" value="ItemId" />
                                            <Workbook.Column label="Name" value="Name" />
                                        </Workbook.Sheet>
                                    </Workbook>
                                </div>
                                : <div>
                                    <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                    <bs4.Button outline color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.getBom_Preview()}>CANCEL</bs4.Button>
                                </div>
                            : ''
                    }
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th>ฐาน<br />ข้อมูล</th>
                            <th>Active</th>
                            <th>Approved</th>
                            <th>BOM<br />Approved</th>
                            <th>BOM<br />PmfBOM<br />Formula</th>
                            <th>BOM<br />Version<br />Approver<br />Personnel<br />Number</th>
                            <th style={{ backgroundColor: '#61ba52' }}>BOM BOMId</th>
                            <th>BOM<br />Check<br />BOM</th>
                            <th>BOM<br />Item<br />GroupId</th>
                            <th style={{ backgroundColor: '#61ba52' }}>BOM Name</th>
                            <th>BOM<br />Approver<br />Personnel<br />Number</th>
                            <th>Construction</th>
                            <th>Invent<br />SiteId</th>
                            <th style={{ backgroundColor: '#61ba52' }}>ItemId</th>
                            <th style={{ backgroundColor: '#61ba52' }}>Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewIBom}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Film_PreviewBomVer